import type { Affine, Pt } from './types.ts';

export const IDENTITY: Affine = [1, 0, 0, 1, 0, 0];

export const apply = ([a, b, c, d, e, f]: Affine, [x, y]: Pt): Pt => [a * x + c * y + e, b * x + d * y + f];

/** `outer` after `inner`: apply(compose(outer, inner), p) === apply(outer, apply(inner, p)). */
export function compose(outer: Affine, inner: Affine): Affine {
  const [a, b, c, d, e, f] = outer;
  const [A, B, C, D, E, F] = inner;
  return [a * A + c * B, b * A + d * B, a * C + c * D, b * C + d * D, a * E + c * F + e, b * E + d * F + f];
}

export function invert([a, b, c, d, e, f]: Affine): Affine {
  const det = a * d - b * c;
  if (Math.abs(det) < 1e-12) throw new Error('invert: singular map');
  return [d / det, -b / det, -c / det, a / det, (c * f - d * e) / det, (b * e - a * f) / det];
}

/** For an SVG `transform` attribute. */
export const toSvg = (m: Affine): string => `matrix(${m.map((v) => +v.toFixed(6)).join(' ')})`;
